import merge from 'deepmerge';
import * as helpers from '../helpers';

export default class Button {
    constructor(buttonEl, options = {}) {
        this.options = merge({
            disableText: '',
            insertTextAfter: '',
            classList: {
                disabled: '-disable',
            },
        }, options);

        this.button = buttonEl;
        this.defaultButtonHTML = buttonEl.innerHTML;
    }

    get buttonEl() {
        return this.button;
    }

    /**
     * Disable button
     * Set custom HTML to it (if given)
     * Set custom required element (if given)
     */
    disable() {
        const { disableText, insertTextAfter } = this.options;
        const { disabled } = this.options.classList;

        helpers.addClass(this.button, disabled);
        this.button.setAttribute('disabled', 'disabled');

        if (disableText) {
            this.button.innerHTML = disableText;
        }

        if (insertTextAfter) {
            this.button.insertAdjacentHTML('afterEnd', `<span class="required">${insertTextAfter}</span>`);
        }
    }

    /**
     * Enable button
     * Set default HTML to it
     * Remove required messages
     */
    enable() {
        const { disableText, insertTextAfter } = this.options;
        const { disabled } = this.options.classList;

        helpers.removeClass(this.button, disabled);
        this.button.removeAttribute('disabled');

        if (disableText) {
            this.button.innerHTML = this.defaultButtonHTML;
        }

        if (insertTextAfter) {
            const insertedText = this.button.parentElement.querySelector('.required');
            // eslint-disable-next-line no-unused-expressions
            insertedText && this.button.parentElement.removeChild(insertedText);
        }
    }
}
